import { API } from '@Providers';
import type { AdoptionFeePayload } from '../interfaces';

export default async function (payload: AdoptionFeePayload) {
  const endpoint = '/api/shelter/animal/update-cart-animal-adoption-fee';

  if (!payload.adoption_fee_id) delete payload.adoption_fee_id;

  return API({ endpoint, method: 'put', payload });
}
